import { PITCH_POINTS_PER_HAND } from './config.js';
export function pitchContractLabel(bid) {
    return `Bid ${bid}`;
}
function bidsFrom(from, to) {
    const out = [];
    for (let p = from; p <= to; p++)
        out.push({ type: 'bid', points: p });
    return out;
}
export const pitchAuction = {
    init({ config, table, dealer }) {
        return {
            seatCount: table.seatCount,
            dealer,
            minBid: config.minBid,
            maxBid: PITCH_POINTS_PER_HAND,
            dealerMayMatch: config.dealerMayMatch,
            stuckDealer: config.stuckDealer,
            calls: [],
            high: null,
            toAct: (dealer + 1) % table.seatCount,
            closed: false,
        };
    },
    legalCalls(state, seat) {
        if (state.closed || seat !== state.toAct)
            return [];
        const isDealer = seat === state.dealer;
        if (state.high === null) {
            // Rules §2.2.4: everybody else passed, so the dealer is stuck.
            if (isDealer && state.stuckDealer)
                return bidsFrom(state.minBid, state.maxBid);
            return [{ type: 'pass' }, ...bidsFrom(state.minBid, state.maxBid)];
        }
        // Rules §2.2.3: the dealer may match the standing bid rather than beat it.
        const floor = isDealer && state.dealerMayMatch ? state.high.points : state.high.points + 1;
        return [{ type: 'pass' }, ...bidsFrom(Math.max(floor, state.minBid), state.maxBid)];
    },
    apply(state, seat, call) {
        const calls = [...state.calls, { seat, call }];
        const high = call.type === 'bid' ? { seat, points: call.points } : state.high;
        const closed = seat === state.dealer;
        return {
            ...state,
            calls,
            high,
            closed,
            toAct: closed ? state.toAct : (seat + 1) % state.seatCount,
        };
    },
    status(state) {
        if (!state.closed)
            return { kind: 'open', toAct: state.toAct };
        if (state.high === null)
            return { kind: 'passedOut' };
        return {
            kind: 'contract',
            contract: {
                pitcher: state.high.seat,
                bid: state.high.points,
                label: pitchContractLabel(state.high.points),
            },
        };
    },
    callKey(call) {
        return call.type === 'pass' ? 'pass' : `bid:${call.points}`;
    },
    describe(call, _config) {
        if (call.type === 'pass') {
            return { label: 'Pass', explain: 'Let someone else pitch this hand.' };
        }
        const p = call.points;
        return {
            label: String(p),
            explain: p === PITCH_POINTS_PER_HAND
                ? 'Shoot the moon: your side must take all 18 points, or lose 18.'
                : `Your side must take at least ${p} of the 18 points, or lose ${p}. You lead first, and your lead names trump.`,
        };
    },
};
//# sourceMappingURL=auction.js.map